import t from "../../../utils/translate";

import {
  RESULTS_ELI_WW,
  RESULTS_ELI_NONE,
  RESULTS_ELI_SUICIDE,
  RESULTS_ELI_SEQUENCE_PREGNANT,
  RESULTS_ELI_SEQUENCE_BREAST_FEEDING,
  STATE_UNSERVICEABLE
} from "../../../utils/eligibility";

const ineligibleContent = {
  [RESULTS_ELI_SUICIDE]: {
    href: "https://www.weightwatchers.com/us/how-it-works/points-program",
    applangaKey: t("JS_INELIGIBLE_SUICIDE"),
    interpolations: {},
    header: t("SEQUENCE_INELIGIBLE_HEADER_KEEP_IN_TOUCH")
  },
  [RESULTS_ELI_WW]: {
    href: "https://www.weightwatchers.com/us/how-it-works/points-program",
    applangaKey: t("JS_INELIGIBLE_SHOW_WW"),
    interpolations: {},
    header: t("SEQUENCE_INELIGIBLE_HEADER_KEEP_IN_TOUCH")
  },
  [RESULTS_ELI_NONE]: {
    href: "",
    applangaKey: t("NOT_ELIGIBLE_BODY2"),
    interpolations: {},
    header: t("NOT_ELIGIBLE_HEADER")
  },
  [RESULTS_ELI_SEQUENCE_PREGNANT]: {
    href: "",
    applangaKey: t("SEQUENCE_INELIGIBLE_PREGNANT"),
    interpolations: {},
    header: t("SEQUENCE_INELIGIBLE_HEADER_KEEP_IN_TOUCH")
  },
  [RESULTS_ELI_SEQUENCE_BREAST_FEEDING]: {
    href: "",
    applangaKey: t("SEQUENCE_INELIGIBLE_BREAST_FEEDING"),
    interpolations: {},
    header: t("SEQUENCE_INELIGIBLE_HEADER_KEEP_IN_TOUCH")
  },
  [STATE_UNSERVICEABLE]: {
    href: "https://www.weightwatchers.com/us/how-it-works/points-program",
    applangaKey: t("JS_INELIGIBLE_STATE_UNSERVICEABLE"),
    interpolations: {},
    header: t("JS_COMING_SOON")
  }
};

export default ineligibleContent;
